import React, { useEffect, useState } from 'react';
import GlobalStyle from '../../styles/globalStylesV2';
import ParentingGeneralItems from '../Parenting/ParentingGeneralItems';
import { getParentingDataEnglish } from '../../Utils/i18Utils/Parenting';
import { SkeletonBox } from '../Product/Skeleton/styled';
import { SkeletonContainer } from './styled';
const Community = () => {
  const [parentingData, setParentingData] = useState({
    parentingPageData: null,
    questionData: null,
    recentlyAskedQues: null,
  });
  const [isLoading, setIsLoading] = useState(true);

  const fetchParentingData = async () => {
    try {
      const data = await getParentingDataEnglish();
      setParentingData({
        parentingPageData: data.props.parentingPageData,
        questionData: data.props.questionData,
        recentlyAskedQues: data.props.recentlyAskedQues,
      });
    } catch (error) {
      console.error('Error fetching parenting data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchParentingData();
  }, []);

  if (isLoading) {
    return (
      <>
        <GlobalStyle />
        <SkeletonContainer>
          <div className="singleSkeleton">
            <SkeletonBox height="325px" width="100%" />
          </div>
          <div className="singleSkeleton">
            <SkeletonBox height="120px" width="100%" />
          </div>
          <div className="singleSkeleton">
            <SkeletonBox height="180px" width="100%" />
          </div>
        </SkeletonContainer>
      </>
    );
  }

  const { parentingPageData, questionData, recentlyAskedQues } = parentingData;

  return (
    <>
      <GlobalStyle />
      <ParentingGeneralItems
        parentingPageData={parentingPageData}
        isStagePage={false}
        recentlyAskedQues={recentlyAskedQues}
        questionData={questionData}
      />
    </>
  );
};

export default Community;
